import messages from '../../../locale/messages'
import { inputDescLimit, inputTextLimit } from '../../../helpers/FieldRestriction';

const validate = values => {

  const errors = {}

  if (values.content) {

    let errorStaticContent = [];
    if (values?.content?.map((item, index) => {
      const dynamicContentError = {}
      let content = item?.content?.replace('<p>', '')?.replace('</p>', '');
      const stripped = item?.content?.replace(/<[^>]+>/g, "")?.replace(/&nbsp;/gi, "")?.replace(/\s+/g, "")?.trim();
      if (!item?.content || content.trim() === '' || !stripped) {
        dynamicContentError.content = messages.required;
        errorStaticContent[index] = dynamicContentError;
      }
      if (!item?.language || item?.language.toString().trim() === '') {
        dynamicContentError.language = messages.required;
        errorStaticContent[index] = dynamicContentError;
      }
    }));
    if (errorStaticContent?.length > 0) errors.content = errorStaticContent;
  }

  if (!values.metaTitle) {
    errors.metaTitle = messages.required;
  } else if (values.metaTitle.trim() == "") {
    errors.metaTitle = messages.required
  } else if (values.metaTitle.length > inputTextLimit) {
    errors.metaTitle = messages.inputTextLimitError;
  }

  if (!values.metaDescription) {
    errors.metaDescription = messages.required;
  } else if (values.metaDescription.trim() == "") {
    errors.metaDescription = messages.required
  } else if (values.metaDescription.length > inputDescLimit) {
    errors.metaDescription = messages.inputDescLimitError;
  }

  return errors
}

export default validate
